import React, { useCallback } from 'react'
import GPX from '../lib/GPX/Gpx'
import Button from '@mui/material/Button'
import Icon from '@mui/material/Icon'
import { LatLngTuple } from 'leaflet'
import { fromLatLngTupleToLatLngLiteral } from 'lib/latLngConversion'

interface DownloadGpxButtonProps {
  path: LatLngTuple[]
  name: string
  disabled: boolean
}
export default function DownloadGpxButton({
  path,
  name,
  disabled,
}: DownloadGpxButtonProps) {
  const downloadGPxFile = useCallback(() => {
    const element = document.createElement('a')
    const gpx = new GPX()
    const latLngLiterals = path.map(fromLatLngTupleToLatLngLiteral)
    gpx.setTrackAndName(name, latLngLiterals)
    const file = new Blob([gpx.toString()], {
      type: 'application/gpx+xml',
    })
    element.href = URL.createObjectURL(file)
    element.download = `${name}.gpx`
    document.body.appendChild(element) // Required for this to work in FireFox
    element.click()
  }, [name, path])

  return (
    <Button
      variant='outlined'
      size='small'
      onClick={downloadGPxFile}
      disabled={disabled}
    >
      <Icon>save_alt</Icon>
      Download GPX
    </Button>
  )
}
